import { Injectable } from '@angular/core';
import { ApiServiceBase } from '@api/abstracts';
import { AvailableSlotsApi, TimeslotError, Timeslots } from '@shared/services/timeslots/models';
import { appointmentSerializer } from '@shared/services/timeslots/serializers';
import { envConfiguredNetworkId } from '@shared/utils';
import { addDays, format } from 'date-fns';
import { map, Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class TimeslotsService extends ApiServiceBase<AvailableSlotsApi> {
  constructor() {
    super('timeslots', 'timeslots', 'fournierWebservice');
  }

  getTimeslots(storeUuid: string): Observable<Timeslots[] | TimeslotError> {
    const startDate = format(new Date(), 'yyyy-MM-dd');
    const endDate = format(addDays(new Date(), 15), 'yyyy-MM-dd');

    return this.customRequest<AvailableSlotsApi>({
      method: 'GET',
      url: `store/${storeUuid}/dates/${startDate}/${endDate}?networkId=${envConfiguredNetworkId(this.language.region)}`,
    }).pipe(map((slots) => appointmentSerializer(slots, this.language.locale)));
  }
}
